<template>
  <v-dialog v-model="dialog" width="350px">
    <v-card>
      <v-card-title class="grey lighten-2">{{
        $t("modal.cookingMeat")
      }}</v-card-title>
      <v-card-text>
        <v-radio-group v-model="cookingPoint">
          <v-radio
            :label="this.$t('modal.wellCooked')"
            value="MUY HECHA"
            class="mt-3"
          ></v-radio>
          <v-radio
            :label="this.$t('modal.toThePoint')"
            value="AL PUNTO"
            class="mt-3"
          ></v-radio>
          <v-radio
            :label="this.$t('modal.underCooked')"
            value="POCO HECHA"
            class="mt-3"
          ></v-radio>
        </v-radio-group>
      </v-card-text>
      <v-card-actions class="d-flex justify-end">
        <v-btn text @click="dialog = false">{{ $t("common.close") }}</v-btn>
        <v-btn outlined @click="onDone">{{ $t("common.done") }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "CookingPointsDialog",
  data() {
    return {
      cookingPoint: "MUY HECHA",
      item: null,
      dialog: false
    };
  },
  methods: {
    open(item) {
      this.item = item;
      this.dialog = true;
    },
    close() {
      this.dialog = false;
      this.cookingPoint = null;
    },
    onDone() {
      if (this.cookingPoint) {
        this.item.name = this.item.name + " " + `( ${this.cookingPoint} )`;
        this.item.orderActual = this.item.order;
        this.item.order = this.item.order + " " + `( ${this.cookingPoint})`;
        if (this.cookingPoint === "MUY HECHA") {
          this.item.order_translations = {
            en:
              this.translateToOneLang("name", this.item, "en") +
              " " +
              "( Well cooked )",
            es:
              this.translateToOneLang("name", this.item, "es") +
              " " +
              "( MUY HECHA )",
            de:
              this.translateToOneLang("name", this.item, "de") +
              " " +
              "( Gut gekocht )",
            fr:
              this.translateToOneLang("name", this.item, "fr") +
              " " +
              "( Bien cuit )",
            it:
              this.translateToOneLang("name", this.item, "it") +
              " " +
              "( Ben cotto )"
          };
        }
        if (this.cookingPoint === "AL PUNTO") {
          this.item.order_translations = {
            en:
              this.translateToOneLang("name", this.item, "en") +
              " " +
              "( To the point )",
            es:
              this.translateToOneLang("name", this.item, "es") +
              " " +
              "( AL PUNTO )",
            de:
              this.translateToOneLang("name", this.item, "de") +
              " " +
              "( Auf den Punkt )",
            fr:
              this.translateToOneLang("name", this.item, "fr") +
              " " +
              "( Jusqu'au point )",
            it:
              this.translateToOneLang("name", this.item, "it") +
              " " +
              "( Al punto )"
          };
        }
        if (this.cookingPoint === "POCO HECHA") {
          this.item.order_translations = {
            en:
              this.translateToOneLang("name", this.item, "en") +
              " " +
              "( Undercooked )",
            es:
              this.translateToOneLang("name", this.item, "es") +
              " " +
              "( POCO HECHA )",
            de:
              this.translateToOneLang("name", this.item, "de") +
              " " +
              "( Ungekocht )",
            fr:
              this.translateToOneLang("name", this.item, "fr") +
              " " +
              "( Pas assez cuit )",
            it:
              this.translateToOneLang("name", this.item, "it") +
              " " +
              "( Poco cotto )"
          };
        }
      } else {
        this.item.order_translations = {
          en: this.translateToOneLang("name", this.item, "en"),
          es: this.translateToOneLang("name", this.item, "es"),
          de: this.translateToOneLang("name", this.item, "de"),
          fr: this.translateToOneLang("name", this.item, "fr"),
          it: this.translateToOneLang("name", this.item, "it")
        };
      }
      console.log("this.item", this.item);
      if (!this.item.isMenuGroupProduct) {
        this.$store.commit("addToCart", { item: this.item, update: true });
        this.$store.dispatch("addStripeProductToCart", this.item);
        this.$forceUpdate(); // Force update to fetch cart data (for displaying the new quantity)
      } else {
        this.$store.commit("saveMenuGroupData", {
          item: this.item,
          update: true
        });
        this.$emit("setMenuGroupItem", this.item);
      }
      this.close();
    }
  }
};
</script>

<style></style>
